import { Component, OnInit, Inject, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
  MatDialogConfig
} from '@angular/material';
import { ProductService } from 'src/app/_service/product.service';
import { ProductLabelComponent } from 'src/app/product-label/product-label.component';
import { AuthService } from '../../_service/auth.service';
import { AuthConfigService } from '../../_service/auth-config.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { parseTemplate } from '@angular/compiler';
import {MatTooltipModule} from '@angular/material/tooltip';
import { FileuploadService } from 'src/app/_service/fileupload.service';
import { FileuploadComponent } from 'src/app/fileupload/fileupload.component';
import { fromEvent, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.css']
})
export class ProductPageComponent implements OnInit {

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  constructor(
    private dialogRef: MatDialogRef<ProductPageComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private productService: ProductService,
    private dialog: MatDialog,
    private fileService: FileuploadService,
    private authService: AuthService,
    private authConfigService: AuthConfigService,
    private alertify: AlertifyService,
    private cdr: ChangeDetectorRef
  ) {}

  productId = this.data['productId'];
  ref_id = this.data['ref_id'];
  selectedRow = this.data.selectedRow;
  product_name = this.data.product_name;
  product_code = this.data.product_code;
  product_code_array = this.data.product_code_array;
  synonyms = this.data.synonyms;
  cas_no = this.data.cas_no;
  mfg_detail = this.data.mfg_detail;
  exempt = this.data.exempt;
  msds_id = this.data.msdsId;
  internal = this.data['internal'];
  productDetail: any;
  sdsCloudProductDetail: any;
  productDetailInfo: any = {};
  pictogramImage: any = [];
  productDetailLoaded = false;

  productSelectedRow = true;

  model: any = {};
  productName: any;
  productCode: any;
  casNo: any;
  manufacturerDetails: any;
  signalWords: any;
  hazardClass: any;
  isInternal: any;

  fileInfo: any = null;

  loading = false;
  whmisExemptValue: any;
  discontinuedValue: any;
  notesValue = false;

  sdsexists: any;
  mobile = false;
  innerWidth: any;
  externalProductId: string;
  linkCopied = false;

  ngOnInit() {
    // detect width onload
    this.innerWidth = window.innerWidth;
    this.getProductDetail();
  }

  // recheck width after change
  ngAfterViewChecked() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 690) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    this.cdr.detectChanges();
  }

  getProductDetail() {
    const params = new URLSearchParams();

    if (this.productId.length !== 0) {
      params.append('productId', this.productId);
    }

    return this.productService
      .getSearchProductDetail(params).subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.productDetailLoaded = true;
          }
        this.productDetail = res.body;

        console.log(res.body);

        for (const fn of this.productDetail) {
          if (fn.fileName) {
            this.sdsexists = true;
          } else {
            this.sdsexists = false;
          }
          this.externalProductId = fn.externalProductId;
        }

        // for (const product of this.productDetail) {
        //   // console.log(product.discontinued);
        //   if (product.discontinued === 'Yes') {
        //     this.discontinuedValue = 'This product has been discontinued';
        //   } else if (product.discontinued === null) {
        //     this.discontinuedValue = 'N/A';
        //   } else {
        //     this.discontinuedValue = product.discontinued;
        //   }
        // }

        // hide notes if empty string or null
        for (const notes of this.productDetail) {
          if (notes.notes === '' || notes.notes === null) {
            this.notesValue = true;
          } else {
            this.notesValue = false;
          }
        }

        // for (const whimsProduct of this.productDetail) {
        //   if (whimsProduct.whmis_exempt === 'Yes') {
        //     this.whmisExemptValue = 'Product is exempt from WHMIS 2015 requirements';
        //   } else if (whimsProduct.whmis_exempt === null) {
        //     this.whmisExemptValue = 'N/A';
        //   } else {
        //     this.whmisExemptValue = whimsProduct.whmis_exempt;
        //   }
        // }

        for (const row of this.productDetail) {
          if (row.selectedRow) {
            this.productSelectedRow = true;
          } else {
            this.productSelectedRow = false;
          }
        }

        for (const image of this.productDetail) {
          this.pictogramImage = image.pictograms;
        }
        this.productDetailInfo = this.productDetail.health_authority;
      },
       error => {
         this.alertify.error('Unable to retrieve product detail');
       }
      );
  }

  isInActive() {
    if (this.authService.decodedToken.role === 'InActive') {
      return true;
    } else {
      return false;
    }
  }

  getSDSPDF() {
    if (!this.externalProductId) { return; }
    const sdsUrl = `${window.location.origin}/view/${this.externalProductId}`;
    window.open(sdsUrl, '_blank');
  }

  loggedIn() {
    return this.authService.loggedIn();
  }

  copySDSLink() {
    if (!this.externalProductId) { return; }
    const sdsUrl = `${window.location.origin}/view/${this.externalProductId}`;
    navigator.clipboard.writeText(sdsUrl).then(() => {
      this.linkCopied = true;
      setTimeout(() => this.linkCopied = false, 2000);
    });
  }

  openProductLabelGeneration(productId) {
    const dialogRef = this.dialog.open(ProductLabelComponent, {
      width: '1000px',
      height: '600px',
      data: {
        productId: this.productId,
        productName: this.product_name,
        productCode: this.product_code,
        mfg_detail: this.mfg_detail
      }
    });
  }
}
